import { AppointmentAdvancePaymentQuery } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';

import {
   ButtonVariant,
   dispatchSnackbarPositiveEvent,
   ModalCloseButton,
   ModalConfirmButton,
   Notification,
   NotificationSize,
   NotificationType,
   StyledFlex,
   useCopyToClipboardAsync,
} from '@dreryk/react-components';
import { refetchCqrsQuery } from '@dreryk/command-query-react-common';

import { translationKeys } from '../../../translations';
import { phoneNumberSmsCapabilitiesVisitor } from '../../../shared/phoneNumberSmsCapabilitiesVisitor';

import { performPaymentOrderRedirectUrlCqrsGet } from './AppointmentAdvancePaymentLinkShowModalEventInterceptor.utils';

type AppointmentAdvancePaymentLinkModalProps = {
   onlinePaymentId: string;
   phoneNumber: PhoneNumber | null;
   onClose: VoidFunction;
};
export const AppointmentAdvancePaymentLinkModal = (props: AppointmentAdvancePaymentLinkModalProps): JSX.Element => {
   const { copy } = useCopyToClipboardAsync({
      onSuccess: () => {
         dispatchSnackbarPositiveEvent(translationKeys.linkToPaymentHasBeenCopied);
      },
   });

   const handleCopy = async (): Promise<void> => {
      await copy(async () => performPaymentOrderRedirectUrlCqrsGet(props.onlinePaymentId));
   };

   const handleClose = (): void => {
      refetchCqrsQuery(AppointmentAdvancePaymentQuery);
      props.onClose();
   };

   return (
      <>
         <StyledFlex direction={'column'} gap={'18px'}>
            <StyledFlex direction={'column'} gap={'4px'}>
               <Notification
                  testId={'linkToPaymentGeneratedSuccessfully'}
                  label={translationKeys.linkToPaymentGeneratedSuccessfully}
                  type={NotificationType.SUCCESS}
                  size={NotificationSize.NORMAL}
               />
            </StyledFlex>
            {phoneNumberSmsCapabilitiesVisitor(props.phoneNumber, {
               visitSmsCapable: () => (
                  <Notification
                     testId={'smsSendRequested'}
                     label={translationKeys.smsSendRequested}
                     type={NotificationType.SUCCESS}
                     size={NotificationSize.NORMAL}
                  />
               ),
               visitSmsIncapable: () => (
                  <Notification
                     testId={'smsWithLinkSendingFailed'}
                     label={translationKeys.smsWithLinkSendingFailed}
                     type={NotificationType.ERROR}
                     size={NotificationSize.NORMAL}
                  />
               ),
            })}
         </StyledFlex>
         <ModalConfirmButton
            variant={ButtonVariant.SECONDARY}
            testId={'copy'}
            label={translationKeys.copyLink}
            onClick={handleCopy}
         />
         <ModalConfirmButton testId={'close'} label={translationKeys.close} onClick={handleClose} />
         <ModalCloseButton onClick={handleClose} />
      </>
   );
};
